import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { browserHistory } from 'react-router';
import Api from '../Api';
import SosdbRoleAction from '../model/SosdbRoleAction';
import * as actions from '../redux/actions';

const INITIAL_ROLE_SELECT_LIST = [
  { key: '', value: '-Choose-' },
  { key: 'Super', value: 'Super' },
  { key: 'Admin', value: 'Admin' },
  { key: 'Operator', value: 'Operator' },
  { key: 'Fulfillment', value: 'Fulfillment' },
  { key: 'Implementation', value: 'Implementation' },
];

class SosdbRoleActionForm extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = {
      roleSelectList: INITIAL_ROLE_SELECT_LIST,
      inProgress: false,
    };
    this.renderInput = this.renderInput.bind(this);
    this.renderSelect = this.renderSelect.bind(this);
    this.renderCheckbox = this.renderCheckbox.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    // Api.getRoleMapping().then(mapping => {
    //   let roleSelectList = [...INITIAL_ROLE_SELECT_LIST];
    //   let roleKeys = Object.keys(mapping).sort();
    //   for (let roleKey of roleKeys)  {
    //     roleSelectList.push({key: roleKey, value: mapping[roleKey]})
    //   }
    //   this.setState({roleSelectList: roleSelectList});
    // });
  }

  handleDelete(e) {
    e.preventDefault(); // prevent form submit

    let { initialValues, dispatch } = this.props;
    console.log('deleting role action', initialValues);

    this.setState({ inProgress: true }, () => {
      dispatch(actions.deleteSosdbRoleAction(new SosdbRoleAction(initialValues)))
        .then((roleAction) => {
          console.log('deleted roleAction', roleAction);
          this.setState({ inProgress: false });
          browserHistory.goBack();
        })
        .catch((e) => {
          this.setState({ inProgress: false, statusMessage: e.message }, () => {
            let $statusMessage = $(this.refs.statusMessage);
            $statusMessage.removeClass('animated fadeIn');
            setTimeout(() => $statusMessage.addClass('animated fadeIn'), 200);
          });
        });
    });
  }

  static validate(values) {
    const errors = {};

    if (!values.role || values.role.startsWith('-')) {
      errors.role = 'Required';
    }

    if (!values.context) {
      errors.context = 'Required';
    }

    if (!values.description) {
      errors.description = 'Required';
    }

    if (!values.menupage) {
      errors.menupage = 'Required';
    }

    if (!values.controller) {
      errors.controller = 'Required';
    }

    if (!values.action) {
      errors.action = 'Required';
    }

    return errors;
  }

  static warn(values) {
    const warnings = {};
    // if (values && values.email && values.email.indexOf('@readytouch.com') == -1) {
    //   warnings.email = 'Hmm, you are not using readytouch.com...'
    // }
    return warnings;
  }

  renderInput({ input, label, type, disabled, meta: { touched, error, warning } }) {
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <input
          className='pure-input-1-3'
          {...input}
          placeholder={label}
          type={type}
          disabled={disabled}
        />
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderSelect({ input, label, children, meta: { touched, error, warning } }) {
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <select className='pure-input-1-3' {...input} placeholder={label}>
          {children}
        </select>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderCheckbox({ input, label, type, meta: { touched, error, warning } }) {
    return (
      <div className='pure-controls'>
        <label className='pure-checkbox'>
          <input {...input} type='checkbox' /> {label}
        </label>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  render() {
    const { handleSubmit, pristine, reset, submitting, initialValues } = this.props;
    // console.log('initialValues', initialValues);
    let isCreate = initialValues.isCreate;
    let inProgress = submitting || this.state.inProgress;

    return (
      <form
        className='user-form pure-form pure-form-aligned'
        style={{ padding: '20px 0' }}
        onSubmit={handleSubmit}
      >
        <fieldset>
          <Field name='role' component={this.renderSelect} label='Role'>
            {this.state.roleSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='context' component={this.renderInput} type='text' label='Context' />
          <Field name='description' component={this.renderInput} type='text' label='Description' />
          <Field name='menupage' component={this.renderInput} type='text' label='Menu Page' />
          <Field name='controller' component={this.renderInput} type='text' label='Controller' />
          <Field name='action' component={this.renderInput} type='text' label='Action' />
          <Field
            name='isDisabled'
            component={this.renderCheckbox}
            type='checkbox'
            label='Disabled'
          />
          <div className='pure-controls'>
            <button
              style={{ margin: '0 10px' }}
              className='pure-button pure-button-primary'
              type='submit'
              disabled={inProgress}
            >
              {isCreate ? 'Create' : 'Update'}
            </button>

            {!isCreate && (
              <button
                style={{ margin: '0 10px', backgroundColor: 'rgb(240,50,50)' }}
                className='pure-button pure-button-primary'
                disabled={inProgress}
                onClick={this.handleDelete}
              >
                Delete
              </button>
            )}
          </div>
          <input type='hidden' name='isCreate' />
        </fieldset>
      </form>
    );
  }
}

// Decorate the form component
SosdbRoleActionForm = reduxForm({
  form: 'sosdbRoleActionForm', // a unique name for this form
  validate: SosdbRoleActionForm.validate,
  warn: SosdbRoleActionForm.warn,
})(SosdbRoleActionForm);

export default SosdbRoleActionForm;



// WEBPACK FOOTER //
// ./src/components/SosdbRoleActionForm.js